import React from 'react'
import { Link } from 'gatsby'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import kebabCase from "lodash/kebabCase"
import { Dropdown } from 'react-bootstrap'

class TagSearch extends React.Component {
    render() {
        return (
            <>
                <h1 className="title">Quero saber sobre<span>:</span></h1>

                <Dropdown>
                    <Dropdown.Toggle variant="secondary" id="dropdown-basic" aria-label="filter-tag"/>
                    <Dropdown.Menu>
                        {this.props.group.map(tag => (
                            <Link key={tag.fieldValue} to={`/tags/${kebabCase(tag.fieldValue)}`}>
                                {tag.fieldValue}
                            </Link>
                        ))}
                    </Dropdown.Menu>
                    <div className="icon-dropdown">
                        <FontAwesomeIcon icon={faChevronDown} />
                    </div>
                </Dropdown>
            </>
        );
    }
}

export default TagSearch